const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount, onUnmounted, Transition } = Vue;


console.log(sectionSettings);

const pcProductTabs  = createApp({
    name: "PcProductTabs",
    setup() {
        return {}
    },
    delimiters: ["${", "}"]
})

pcProductTabs.component('pc-tabs-wrapper', {
    template: "#pcTabsWrapper",
    setup(props) {
        const productsListOne = ref(sectionSettings.product_list_1);
        const productsListTwo = ref(sectionSettings.product_list_2);
        const tabs = ref([
          { label: '$34.95 Offers', title:"Trios", slot: 'tab1' },
          { label: '$24.95 Offers', title:"Duos", slot: 'tab2' },
        ])
        return {
            sectionSettings,
            productsListOne,
            productsListTwo,
            tabs
        }
    },
    delimiters: ["${", "}"]
});

pcProductTabs.component('pc-tabs', {
    template: "#pcTabs",
    setup(props) {
        const tabs = ref([
            { label: '$34.95 Offers', title:"(2 Options)", slot: 'tab1' },
            { label: '$24.95 Offers', title:"(3 Options)", slot: 'tab2' },
        ])
        const activeTab = ref(0)
        return {
            tabs,
            activeTab
        }
    },
    delimiters: ["${", "}"]
});

pcProductTabs.component('pc-product-card', {
    template: "#pcProductCard",
    props: ["product"],
    setup(props) {
        const selectedVariant = ref(null);
        const firstAvailableIndex = ref();
        const dropdownOpen = ref(false);

        onBeforeMount(() => {
          firstAvailableIndex.value = props.product.variants.findIndex(variant => variant.available);
          selectedVariant.value = props.product.variants[firstAvailableIndex.value];
        })

        onMounted(() => {
          if(window?.okeWidgetApi){
            window.okeWidgetApi.initAllWidgets();
          }
        })

        function handleVariantSelect(event){
          const selectedIndex  = event.target.value;
          firstAvailableIndex.value = selectedIndex;
          selectedVariant.value = props.product.variants[selectedIndex];    
          toggleDropdown();
        }

        async function handleAddToCart(){
            console.log(selectedVariant.value.selling_plan_allocations[0].selling_plan_id)
            let lineItem = [{
                quantity: 1,
				        id: selectedVariant.value.id,
                selling_plan: selectedVariant.value.selling_plan_allocations[0].selling_plan_id
            }]
            const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ items: lineItem }),
            })
        }

        function toggleDropdown(){
          dropdownOpen.value = !dropdownOpen.value;
        }
        
        return {
            selectedVariant,
            firstAvailableIndex,
            dropdownOpen,
            sectionSettings,
            handleVariantSelect,
            handleAddToCart,
            formatMoney,
            calculateDiscount,
            toggleDropdown
        }
    },
    delimiters: ["${", "}"]
});

pcProductTabs.mount("#pcProductTabs");


function calculateDiscount(price, discountValue, discountValueType) {
  if (discountValue === 0 || discountValue === undefined || discountValue === null) {
    return null;
  }
  if (discountValueType === 'PERCENTAGE') {
    let discountedPrice = price * (discountValue / 100);
    return Number(roundNumber(price - discountedPrice, false));
  }
  if (discountValueType === 'FIXED') {
    let discountedPrice = price * (fixedDiscountToPercentage(price / 100, discountValue) / 100);
    console.log(discountedPrice,price,"fixed");
    return Number(roundNumber(price - discountedPrice, false));
  };
}


function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = roundNumber(number / 100, false, precision);
      let parts = number.split("."),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  function roundNumber(num, savings, precision = 2) {
    if (isNaN(num)) {
      return;
    }
  
    let nummm = num.toFixed(3).split(".")[1].slice(1);
    if (nummm > 4 && !savings) {
      let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
      return number.toFixed(precision);
    } else if (nummm < 6 && savings) {
      let number = Math.floor((num + Number.EPSILON) * 100) / 100;
      return number.toFixed(precision);
    } else {
      let number = Math.round((num + Number.EPSILON) * 100) / 100;
      return number.toFixed(precision);
    }
  }